<template>
    <div>
        <transition name="fade">
            <div v-if="$store.state.stateAction.userFreebets > 0 && showPopup" class="popup-backdrop" @click.self="closePopup">
                <div class="popup-box">
                    <h2>{{ getTranslatedText('Promotion Alert!') }}</h2>
                    <p> {{ getTranslatedText('We have credited your account with free bets. Visit My Bets to view them.') }}</p>
                    <button @click="closePopup">{{ getTranslatedText('Close') }}</button>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
    import languageMixins from "@/mixins/language-mixins";

    export default {
        mixins: [languageMixins],
        data() {
            return {
                showPopup: false,
                timeoutId: null
            };
        },
        mounted() {
            this.openPopup();
        },
        methods: {
            openPopup() {
                const lastClosed = localStorage.getItem('showPromoPopUp');
                const twoHours = 2 * 60 * 60 * 1000; // milliseconds in 2 hours

                if (this.$store.state.stateAction.userFreebets > 0 && (!lastClosed || Date.now() - parseInt(lastClosed) > twoHours)) {
                    this.showPopup = true;

                    // Auto-close after 10 seconds
                    clearTimeout(this.timeoutId);
                    this.timeoutId = setTimeout(() => {
                        this.closePopup();
                    }, 10000);
                }
            },
            closePopup() {
                this.showPopup = false;
                localStorage.setItem('showPromoPopUp', Date.now().toString());
                clearTimeout(this.timeoutId);
            }
        }
    };
</script>

<style lang="scss" scoped>

    .popup-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .popup-box {
        background: #ffffff;
        width: 400px;
        min-height: 180px;
        padding: 30px 25px;
        border-radius: 12px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        text-align: center;
        position: relative;
        font-family: Arial, sans-serif;
    }

    .popup-box p {
        font-size: 18px;
        margin-bottom: 20px;
        color: #333;
    }

    .popup-box button {
        padding: 10px 20px;
        font-size: 14px;
        border: none;
        background-color: #007bff;
        color: white;
        border-radius: 6px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .popup-box button:hover {
        background-color: #0056b3;
    }


    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s ease;
    }
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }

    @media screen and (max-width: 600px) {
        .popup-box {
            width: 90%;
            min-height: 160px;
            padding: 20px 15px;
            font-size: 16px;
        }

        .popup-box p {
            font-size: 16px;
        }

        .popup-box button {
            width: 100%;
            padding: 12px;
            font-size: 16px;
        }
    }


</style>